/**
 * Created by claudio iozzia on 03/07/2017.
 */
import {Validator_DcDc_Buck} from "./dcdc_buck_validator";
import {calculate_voutUpperBound} from "../../acdc/validator/acdc__common_validator";
import {Utils} from "../../../../common/utils";
import {ValidatorOutputFn} from "../../../../models/validator/IValidator";
import {Ic, IEntityAlert} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {EntityError} from "../../../../models/EntityAlert";

export class Validator_DcDc_Buck_6902 extends Validator_DcDc_Buck {
  private validatorFn_SingleOutput_Voltage_Buck_6902: ValidatorOutputFn = (ic: Ic, spec: IAppSpec, o: number): IEntityAlert => {
    const _vin = spec.spec.value.input;
    const isAttendibileVinMin: boolean = !spec.spec.note.input.min.hasError && Utils.isValueReal(_vin.min);
    const _vOut = spec.spec.value.output.outputs[o].voltage;

    const vOutUpperBound_prev = calculate_voutUpperBound(ic, spec);
    const vOutUpperBound = isAttendibileVinMin ? Math.min(vOutUpperBound_prev, _vin.min - 2) : vOutUpperBound_prev;

    const result = Utils.acceptInRange(_vOut, ic.vout_min, vOutUpperBound, "Vout", "V");
    return new EntityError(result);
  }

  protected singleOutputV(): ValidatorOutputFn[] {
    return [this.validatorFn_SingleOutput_Voltage_Buck_6902];
  }
}
